import { render, staticRenderFns } from "./formdialog.vue?vue&type=template&id=489a7008&scoped=true"
import script from "./formdialog.vue?vue&type=script&lang=js"
export * from "./formdialog.vue?vue&type=script&lang=js"
import style0 from "./formdialog.vue?vue&type=style&index=0&id=489a7008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489a7008",
  null
  
)

export default component.exports